import { render, staticRenderFns } from "./ModalEditAmount.vue?vue&type=template&id=0655b24a&scoped=true"
import script from "./ModalEditAmount.vue?vue&type=script&lang=js"
export * from "./ModalEditAmount.vue?vue&type=script&lang=js"
import style0 from "./ModalEditAmount.vue?vue&type=style&index=0&id=0655b24a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0655b24a",
  null
  
)

export default component.exports